import classnames from 'classnames'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Spacer, { SpacerSizes } from '~/components/atoms/Spacer/Spacer'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './JobListingDetails.module.css'

export interface JobListingDetailsProps {
  testID?: string
  title: string
  department: string
  location: string
  contractType: string
  summary: string
  body: string
  applicationUrl: string
}

export default function JobListingDetails({
  testID,
  title,
  department,
  location,
  contractType,
  summary,
  body,
  applicationUrl,
}: JobListingDetailsProps) {
  return (
    <div className={styles.base} data-testid={testID}>
      <div className={styles.jobIntroductionWrapper}>
        <Text
          className={styles.title}
          Tag="h1"
          size={TextSizes.primaryTitleLrgPlus}
        >
          {title}
        </Text>
        <Spacer size={SpacerSizes.md} />
        <Text
          className={styles.intro}
          Tag="p"
          size={TextSizes.bodyMed}
          weight={'bold'}
          uppercase
        >
          {department}
          <br />
          {location}
          <br />
          {contractType}
        </Text>
        <Spacer size={SpacerSizes.lg} />

        <div className={styles.summary}>
          <BlockContent
            value={summary as any}
            size={TextSizes.secondaryTitleLrg}
          ></BlockContent>
        </div>
      </div>
      <Spacer size={SpacerSizes.lg} />

      <div className={classnames('prose', styles.content)}>
        <BlockContent
          value={body as any}
          size={TextSizes.bodyMed}
        ></BlockContent>
      </div>

      <Spacer size={SpacerSizes.lg} />

      <div className={styles.buttonCol}>
        <div className={styles.buttonWrapper}>
          <Button iconLeft link={applicationUrl} target="_blank">
            Apply Now
          </Button>
          <Button iconLeft variant={ButtonVariants.secondaryDark} link="/jobs">
            Back to Vacancies
          </Button>
        </div>
      </div>
    </div>
  )
}
